import React, { useState, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Paper,
  TableHead,
  Button,
  IconButton,
  TablePagination,
} from "@material-ui/core";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import { useStyles } from "./styles";
import { format, parseISO, subHours } from "date-fns";
import CreateDialog from "./createDialog";
import DeleteDialog from "./deleteDialog";
import EditDialog from "./editDialog";
import {
  handleGetAllDriver,
  handleGetDevicesNoBonds,
} from "../../../services/peopleManagement/driver";
import CentralizedLoading from "../../../components/CentralizedLoading";
import { toast } from "material-react-toastify";
import { useSelector } from "react-redux";
import { handleGetAllDevicesUtrack } from "../../../services/devicesService";

const rows = [
  {
    id: "ID",
    numeric: false,
    disablePadding: true,
    label: "ID",
  },
  {
    id: "Name",
    numeric: true,
    disablePadding: false,
    label: "Nome do Motorista",
  },
  {
    id: "CNH",
    numeric: true,
    disablePadding: false,
    label: "CNH(Carteira Nacional de Habilitação)",
  },
  {
    id: "ExpirationDateLicense",
    numeric: true,
    disablePadding: false,
    label: "Vencimento da CNH",
  },
  { id: "Phone", numeric: true, disablePadding: false, label: "Telefone" },
  { id: "Rfid", numeric: true, disablePadding: false, label: "RFID" },
  { id: "Edit", numeric: true, disablePadding: false, label: "Editar" },
  { id: "Remove", numeric: true, disablePadding: false, label: "Remover" },
];

class EnhancedTableHead extends React.Component {
  render() {
    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                sortDirection=""
                numeric={row.numeric}
                padding={"15px"}
              >
                {row.label}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
});

let EnhancedTableToolbar = (props) => {
  const { numSelected, classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.spacer} />
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
});

const PassengerTable = (props) => {
  const [dialogCreate, setDialogCreate] = useState(false);
  const [dialogDelete, setDialogDelete] = useState(false);
  const [dialogEdit, setDialogEdit] = useState(false);
  const [itemSelect, setItemSelect] = useState({});
  const [driver, setDriver] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [configurations, setConfigurations] = useState([]);
  const [allDevicesUtrack, setAllDevicesUtrack] = useState([]);
  const customerId = useSelector((store) => store.auth.customer.customer);

  const formatDate = (dateString) => {
    if (dateString === "") {
      return null;
    }
    const dateTz = subHours(parseISO(dateString), 3);

    return format(dateTz, "dd'/'MM'/'yyyy '");
  };

  const { classes } = props;

  const classesB = useStyles();

  const getDataTable = async () => {
    try {
      const response = await handleGetAllDriver(currentPage, rowsPerPage);
      setDriver(response);
    } catch (error) {
      toast.error("Erro ao tentar carregar dados");
    }
  };

  const getDevicesUtrack = async () => {
    const response = await handleGetDevicesNoBonds(customerId);

    setConfigurations(response);
  };

  const getAllDevicesUtrack = async () => {
    try {
      const response = await handleGetAllDevicesUtrack(customerId);
      setAllDevicesUtrack(response);
    } catch (error) {
      toast.error("Erro ao tentar carregar dados");
    }
  };

  useEffect(() => {
    getAllDevicesUtrack();
    getDataTable();
    getDevicesUtrack();
  }, [props.tab]);

  useEffect(() => {
    getDataTable();
  }, [currentPage, rowsPerPage]);

  const openCreateDialog = () => {
    setDialogCreate(true);
  };

  const closeCreateDialog = () => {
    setDialogCreate(false);
  };

  const openDialogDelete = (item) => {
    setItemSelect(item);
    setDialogDelete(true);
  };

  const closeDialogDelete = () => {
    setDialogDelete(false);
  };

  const openDialogEdit = (item) => {
    setItemSelect(item);
    setDialogEdit(true);
  };

  const closeDialogEdit = () => {
    setDialogEdit(false);
  };

  return (
    <Paper className={classes.root}>
      <div className={classesB.divButton}>
        <Button
          className={classesB.txtButton}
          variant="contained"
          onClick={openCreateDialog}
        >
          Adicionar
        </Button>
        <CreateDialog
          close={closeCreateDialog}
          open={dialogCreate}
          reload={getDataTable}
          devicesUtrack={configurations}
        />
        <DeleteDialog
          close={closeDialogDelete}
          open={dialogDelete}
          data={itemSelect}
          reload={getDataTable}
        />
        {dialogEdit && (
          <EditDialog
            close={closeDialogEdit}
            open={dialogEdit}
            data={itemSelect}
            reload={getDataTable}
            customerId={customerId}
            allDevicesUtrack={allDevicesUtrack}
            devices={configurations}
          />
        )}
      </div>
      <EnhancedTableToolbar />
      <div className={classes.tableWrapper}>
        {driver.data ? (
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead />
            <TableBody className={classes.tableBody} padding="15px">
              {driver.data.map((n) => {
                return (
                  <TableRow hover tabIndex={-1} key={n.id}>
                    <TableCell component="th" scope="row" padding="15px">
                      {n.id}
                    </TableCell>
                    <TableCell>{n.name}</TableCell>
                    <TableCell>{n?.cnh || ""}</TableCell>
                    <TableCell>
                      {formatDate(n?.expirationDateCnh || "")}
                    </TableCell>
                    <TableCell>{n?.phone || ""}</TableCell>
                    <TableCell>{n?.rfid || ""}</TableCell>
                    <TableCell>
                      <IconButton>
                        <EditIcon onClick={() => openDialogEdit(n)} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton>
                        <DeleteIcon onClick={() => openDialogDelete(n)} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <CentralizedLoading text="Buscando dados..." />
        )}
      </div>
      <TableRow>
        <TablePagination
          colSpan={rows.length}
          rowsPerPageOptions={[5, 10, 20]}
          count={driver.totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage - 1}
          onChangePage={(event, newPage) => setCurrentPage(newPage + 1)}
          onChangeRowsPerPage={(event) =>
            setRowsPerPage(parseInt(event.target.value))
          }
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
          labelRowsPerPage={"Linhas por página:"}
        />
      </TableRow>
    </Paper>
  );
};

PassengerTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PassengerTable);
